import axios from 'axios';
import { CONSUMERS } from '../../../Utilities/APIs';

const LOGIN_URL = CONSUMERS + 'login'
const REGISTER_URL = CONSUMERS + 'register'

// Register user

async function register(consumerData) {
    
    const response = await axios.post(REGISTER_URL, consumerData);

    if (response.data) {
        localStorage.setItem('consumer', JSON.stringify(response.data))
    }

    return response.data

}

async function login(consumerData) {
    
    const response = await axios.post(LOGIN_URL, consumerData);

    if (response.data) {
        localStorage.setItem('consumer', JSON.stringify(response.data))
    }

    return response.data

}

const logout = () => {
    localStorage.removeItem('consumer')
}

const authService = {
    register,
    logout,
    login
}

export default authService;